import { render, staticRenderFns } from "./noticeJB.vue?vue&type=template&id=d4ea254a&scoped=true"
import script from "./noticeJB.vue?vue&type=script&lang=js"
export * from "./noticeJB.vue?vue&type=script&lang=js"
import style0 from "./noticeJB.vue?vue&type=style&index=0&id=d4ea254a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ea254a",
  null
  
)

export default component.exports